module.exports = {
    signup: {
        rules: [
            { name: 'required', fields: ['firstName', 'lastName', 'email', 'st', 'specialty', 'consent', 'recaptcha', 'zip', 'institution'], required: true },
            { name: 'valid length', fields: ['firstName', 'lastName'], validators: [/^[\s\S]{2,100}$/] },
            { name: 'valid email', fields: ['email'], validators: [/^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/, /^.{0,100}$/] },
            { name: 'valid phone', fields: ['phone'], validators: [/^[(]?(\d{3})[)]?[-|\s]?(\d{3})[-|\s]?(\d{4})$/] },
            { name: 'valid zip', fields: ['zip'], validators: [/(^\d{5}$)|(^\d{5}-\d{4}$)/] },
            { name: 'valid consent', fields: ['consent'], validators: [[true]] },
            { name: 'valid recaptcha', fields: ['consent'], validators: [[true]] },
            { name: 'valid specialty', fields: ['specialty'], validators: [['Prescriber','Non-prescriber', 'PT committee member', 'Policy maker']]},
            { name: 'valid state', fields: ['st'], validators: [['AL','AK','AZ','AR','CA','CO','CT','DE','DC','FL','GA','HI','ID','IL','IN','IA','KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NY','NC','ND','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VT','VA','WA','WV','WI','WY']] },
        ],
    },
    unsubscribe: {
        rules: [
            { name: 'required', fields: ['firstName', 'lastName', 'email'], required: true },
            { name: 'valid email', fields: ['email'], validators: [/^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/, /^.{0,100}$/] },
            { name: 'two characters min', fields: ['firstName', 'lastName'], validators: [/^.{2,}$/] },
            { name: 'one hundred characters max', fields: ['firstName', 'lastName'], validators: [/^.{0,100}$/] },
            { name: 'no special characters', fields: ['firstName', 'lastName'], validators: [/^[a-zA-Z]+$/] },
        ]
    }
};
